module.exports = new __parcel__URL__("WhiteboardsPaywall.cf2c63af.svg").toString();